import React, { type PropsWithChildren } from 'react'
import classnames from 'classnames'

import { useBrandColor } from '../../../../Designs/blocs/brandResolvers'
import type { IndexedElement } from '../../../../firebase/model/mix'

import './ElementPositioner.scss'

interface ElementPositionerProps {
  element: IndexedElement
}
const ElementPositioner = ({
  element,
  children,
}: PropsWithChildren<ElementPositionerProps>) => {
  const resolveBrandColor = useBrandColor()

  return (
    <div
      className={classnames('element-positioner')}
      style={{
        left: `${element.position.x}%`,
        top: `${element.position.y}%`,
        width: `${element.position.w}%`,
        height: `${element.position.h}%`,
        zIndex: element.index,
        backgroundColor: resolveBrandColor(element.style?.backgroundColor),
        '--border-radius-top-left': element.radius?.topLeft,
        '--border-radius-top-right': element.radius?.topRight,
        '--border-radius-bottom-left': element.radius?.bottomLeft,
        '--border-radius-bottom-right': element.radius?.bottomRight,
        '--outline-width': element.outline?.width,
        '--outline-color': resolveBrandColor(element.outline?.color),
      }}
    >
      {children}
    </div>
  )
}

export { ElementPositioner }
